import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Swal from 'sweetalert2';
import { ScriptBlockAllowServices } from '../../services/ScriptBlockAllowServices';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import SubBrokerDropdown from '../components/SubBrokerDropdown';
import '../custom.css';

function Scriptblockallow() {

  const [loading, setLoading] = useState(false);
  const [blockedScripts, setBlockedScripts] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSubBroker, setSelectedSubBroker] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState('');
  const [selectedScript, setSelectedScript] = useState('');
  const [userId, setUserId] = useState(null);
  const [script, setScript] = useState(null);
  const [segment, setSegment] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);


  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  useEffect(() => {
    setLoading(true);
    ScriptBlockAllowServices.getBlockedScript({ 'adminId': user.adminId }).then(res => {
      setLoading(false);
      if (res.code === 1) {
        if (res.data.blockedScripts.length > 0) {
          setBlockedScripts(res.data.blockedScripts);
        }
      }
    });
  }, []);

  const handleSubmit = () => {
  
    let block = {};


    if (selectedClient) {
      block.userId = selectedClient.userId;
      block.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      block.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      block.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      block.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      block.adminId = selectedAdmin.value;
    }
    else {
      block.adminId = user.adminId;
    }

    setLoading(true);
    ScriptBlockAllowServices.getBlockedScript(block).then(res => {
      setLoading(false);
      if (res.code === 1) {
        if (res.data.blockedScripts.length > 0) {
          setBlockedScripts(res.data.blockedScripts);
        }
        else {
          setBlockedScripts([]);
        }
      }
    });

  }

  const handleAdd = () => {
    
    if (!selectedAdmin && !selectedMaster && !selectedSubBrokerId && !selectedClientId && !selectedMarket && !selectedScript) {
      Swal.fire({
        icon: "error",
        text: "Please fill required fields!",
      });
      return;
    }
    let add = {
      segment: selectedMarket,
      script: selectedScript
    };

    if (selectedClient) {
      add.userId = selectedClient.userId;
    } else if (selectedSubBrokerId) {
      add.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      add.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      add.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      add.adminId = selectedAdmin.value;
    }
    else {
      add.adminId = user.adminId;
    }


    ScriptBlockAllowServices.getAddBlockedScript(add).then(res => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Blocked Successfully!!.."
        });

        ScriptBlockAllowServices.getBlockedScript({ 'adminId': user.adminId }).then(res => {
          if (res.code === 1) {
            if (res.data.blockedScripts.length > 0) {
              setBlockedScripts(res.data.blockedScripts);
            }
          }
        });
      }
      else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: '<a href="#">Why do I have this issue?</a>'
        });
      }
    });

  }

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleScriptReset = () => {
    setSelectedScript(null);
  };

  const handleSelectedClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
  };


  const handleUnblock = (event) => {
    const rowId = event.target.getAttribute("row-id");
    const dataId = event.target.getAttribute("data-id");
    const id = dataId.split("#")[0];
    const scr = dataId.split("#")[1];
    const selectedId = blockedScripts.find(item => item.id === id && item.script === scr);

    if (selectedId) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes, Unblock it!"
      }).then((result) => {
        if (result.isConfirmed) {
          const unblock = {
            script: selectedId.script,
            segment: selectedId.segment
          };
          if (selectedId.type === 'USER') {
            unblock.userId = selectedId.id;
          }
          else {
            unblock.adminId = selectedId.id;
          }

          ScriptBlockAllowServices.getUnblock(unblock).then(resp => {
            if (resp.code === 1) {
              setBlockedScripts(blockedScripts.map(row => {
                if (row.id === id && row.script === scr) {
                  return null;
                }
                return row;
              }).filter(Boolean));
            } else {
              alert('Failed to unblock.');
            }
          });

          Swal.fire({
            title: "Unblocked!",
            text: "Script has been Unblocked.",
            icon: "success"
          });
        }
        else {
          return;
        }
      });


    }
  };

  const handleClick = (event) => {
    if (event.target.classList.contains("table-btn")) {
      handleUnblock(event);
    }
  };


  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [userId, script, segment, blockedScripts]);

  const columns = [
    {
      title: "CLIENT NAME",
      data: "name",
      render: function (data, type, row) {
        let adminTypeAbbr = '';
        if (row.type === 'ADMIN') {
          adminTypeAbbr = 'A';
        } else if (row.type === 'MASTER') {
          adminTypeAbbr = 'M';
        } else if (row.type === 'BROKER' || row.type === 'SUBBROKER') {
          adminTypeAbbr = 'B';
        } else if (row.type === 'USER') {
          adminTypeAbbr = 'C';
        }
        return `${row.name} (${adminTypeAbbr})`;
      },
      className: "font-bold fss-1 ",
    },
    {
      title: "MARKET",
      data: "segment",
      className: "font-bold fss-1 ",
    },
    {
      title: "SCRIPT",
      data: "script",
      className: "font-bold fss-1 ",
    },
    {
      title: "TIME",
      data: "audittimestamp",
      className: "font-bold fss-1 ",
    },
    {
      title: 'REMOVE',
      data: '',
      className: 'font-bold fss-1 ',
      render: (data, type, row, full, meta) => {
        return `
        <button  class="table-btn font-bold fss-1 bg-success btn-rounded"  row-id="${full.row}" data-id="${row.id + "#" + row.script}" >Unblock</button>
        `;
      },
    },

  ];

  return (

    <div>

      <Card className='mt-2'>
        <Card.Body>
          <Row>
            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={3} xs={4}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={3} xs={4}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}

                  />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'BROKER' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={3} xs={4}>
                  <b className="fss-05">BROKER</b>
                  <SubBrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                    setSelectedOption={setSelectedSubBrokerId}
                    setSelectedClientId={setSelectedClient}
                  />
                </Col>
              </> : ""}

            <Col sm={3} xs={4}>
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                selectedSubBrokerId={selectedSubBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>

            <Col sm={3} xs={4}>
              <b className='fss-05'>MARKET</b>
              <MarketDropdown
                allScripts={allScripts}
                onMarketChange={handleMarketChange} onScriptReset={handleScriptReset} />
            </Col>

            <Col sm={3} xs={4}>
              <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />
            </Col>

            <Col sm={3} xs={6} xl={2} className='mt-4' >
              <Button variant="danger" size="sm" className='me-1' onClick={handleAdd}>
                +Add
              </Button>
              <Button variant="success" size="sm" className='me-1' onClick={handleSubmit} >
                Search
              </Button>
            </Col>

          </Row>

        </Card.Body>
      </Card>


      <Card className="mt-2">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                id="table"
                className=" table  table-bordered bg-head-secondary fss-08 white-bordered-table"
                columns={columns}
                data={blockedScripts}
              />
            )}
          </div>
        </Card.Body>
      </Card>


    </div>


  );

}
export default Scriptblockallow;